export default __webpack_public_path__ + "4235499.png";